<template>
  <div>
    <span v-show="$vuetify.display.smAndUp" class="text-no-wrap">
      <v-btn
        class="rounded-0 rounded-s-lg"
        :color="language === 'en' ? 'black' : 'grey'"
        :variant="language === 'en' ? 'flat' : 'outlined'"
        @click="changeLanguage('en')"
        >ENG</v-btn
      >
      <v-btn
        class="rounded-0 rounded-e-lg"
        :color="language === 'th' ? 'black' : 'grey'"
        :variant="language === 'th' ? 'flat' : 'outlined'"
        @click="changeLanguage('th')"
        >ไทย</v-btn
      >
    </span>
    <span v-show="$vuetify.display.xs">
      <v-btn
        icon
        color="indigo"
        variant="flat"
        elevation="3"
        @click="toggleLanguage()"
      >
        <span :class="language === 'en' ? 'big-text' : 'small-text'">en</span>
        <span :class="language === 'th' ? 'big-text' : 'small-text'">th</span>
      </v-btn>
    </span>
  </div>
</template>

<script>
export default {
  methods: {
    changeLanguage(lang) {
      if (lang == "en") {
        this.$root.$i18n.locale = "en";
        localStorage.setItem("language", "en");
      } else {
        this.$root.$i18n.locale = "th";
        localStorage.setItem("language", "th");
      }
    },
    toggleLanguage() {
      if (this.$root.$i18n.locale === "en") {
        this.$root.$i18n.locale = "th";
        localStorage.setItem("language", "th");
      } else {
        this.$root.$i18n.locale = "en";
        localStorage.setItem("language", "en");
      }
    },
  },
  computed: {
    language() {
      return this.$root.$i18n.locale;
    },
  },
  created() {
    if (localStorage.getItem("language") != null)
      this.$root.$i18n.locale = localStorage.getItem("language");
    else localStorage.setItem("language", this.$root.$i18n.locale);
  },
};
</script>

<style lang="scss" scoped>
.small-text {
  font-size: 8px;
}

.big-text {
  font-size: 13px;
}
</style>
